
import { defineComponent } from "vue";
import { hexToRgba, rgbaToHex } from "../utils/ColorUtils";
import { devMode } from "../utils/manager/WorkspaceManager";
import { vueRef } from "../utils/VueRef";

export default defineComponent({
  data() {
    return {
      devMode: vueRef(devMode),
      colorHex: "#FFFFFF",
      alpha: 1.0
    };
  },

  props: {
    color: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: "Color"
    }
  },

  emits: ["update:color"],

  watch: {
    color: {
      immediate: true,
      handler(val: string) {
        const conv = rgbaToHex(val);

        this.colorHex = conv.hex;
        this.alpha = conv.alpha;
      }
    }
  },

  methods: {
    updateColor() {
      this.$emit("update:color", hexToRgba(this.colorHex, this.alpha));
    }
  }
});
